import { DatabaseClient } from './DatabaseClient';
import { schemaMigrator } from './SchemaMigrator';

let initPromise: Promise<void> | null = null;

export function initializeDatabase(client: DatabaseClient): Promise<void> {
  if (!initPromise) {
    initPromise = schemaMigrator
      .migrateIfNeeded(client)
      .then(() => undefined)
      .catch((err) => {
        initPromise = null;
        throw err;
      });
  }
  return initPromise;
}
